<template>
  <div>
    <p
      v-if="selectedItem.title"
      class="hyp-methodology-title application-heading"
    >
      {{ selectedItem.title }}
    </p>
    <p v-if="selectedItem.body" v-html="selectedItem.body"></p>

    <div class="definition-card-container" v-if="showRiskLevels">
      <v-card
        v-for="level in riskLevels"
        :key="level.value"
        class="mb-2 definition-card"
      >
        <v-card-title class="mb-3 pa-2 definition-card-title">
          <div class="pull-left" :style="getCardTitleStyle(level)"></div>
          <div class="pull-left ml-2">{{ level.name.toUpperCase() }}</div>
          <div class="clearfix"></div>
        </v-card-title>
        <v-card-subtitle
          class="definition-card-subtitle"
          v-html="riskLevelBody(level)"
        >
        </v-card-subtitle>
      </v-card>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
import lodashGet from "lodash/get";
import camelCase from "lodash/camelCase";
import lodashOrderBy from "lodash/orderBy";
import lodashFind from "lodash/find";

import { RISK_LEVELS } from "@/common/constants/controlRisks/risks";
export default {
  name: "MethodologyDetails",
  props: {
    selectedItem: {
      type: Object,
    },
  },
  computed: {
    riskLevels() {
      return lodashOrderBy(RISK_LEVELS, ["value"]);
    },
    showRiskLevels() {
      return this.selectedItem.hasOwnProperty(
        camelCase(this.riskLevels[0].name)
      );
    },
  },
  methods: {
    riskLevelBody(level) {
      return this.selectedItem[camelCase(level.name)];
    },
    getCardTitleStyle(level) {
      if (level && level.value) {
        const bgColor = this.getBgColor(level.value);
        return {
          "background-color": bgColor,
          width: "15px",
          height: "15px",
          "border-radius": "15px",
        };
      }
      return null;
    },
    getBgColor(value) {
      if (value) {
        const level = lodashFind(RISK_LEVELS, { value: value });
        if (lodashGet(level, "bgColor")) {
          return level.bgColor;
        }
      }
      return null;
    },
  },
};
</script>

<style scoped>
.hyp-methodology-title {
  font-size: 24px;
  margin-bottom: 30px;
}
.definition-card-title {
  font-size: 14px;
}
.definition-card-subtitle {
  font-size: 14px;
}
</style>
